import { useEffect, useMemo } from 'react';

import type { FormInstance } from 'antd';

import { type ConnectorConfig, type ConnectorField, type UpdateConnectorRequest } from '@/entities/connector';

type UseConnectorConfigDefaultsParams = {
  form: FormInstance<UpdateConnectorRequest>;
  fields: readonly ConnectorField[];
};

export const useConnectorConfigDefaults = ({ form, fields }: UseConnectorConfigDefaultsParams) => {
  const schemaDefaultConfig = useMemo<ConnectorConfig>(() => {
    return fields.reduce<ConnectorConfig>((acc, field) => {
      acc[field.label] = '';
      return acc;
    }, {});
  }, [fields]);

  useEffect(() => {
    const currentConfig = form.getFieldValue('config');

    if (!currentConfig || Object.keys(currentConfig).length === 0) {
      form.setFieldValue('config', schemaDefaultConfig);
    }
  }, [form, schemaDefaultConfig]);
};
